import { formatCurrency } from "utils/common";

export const formatMoneyField = ({
  currency,
  amount,
}: {
  currency: string;
  amount: number;
}) => {
  return `${formatCurrency({ currency })}${amount}`;
};
